﻿import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Position, Tooltip } from "@blueprintjs/core";
import './Status.css';
import classNames from 'classnames';
import { ShowHide } from 'components/layout';
import './EmployeeCircleStatus.css';
import './StatusPanel.css';

export function CircleStatus(
    {
        background = '',
        status = '',
        iconClass = '',
        tooltip = '',
        loading = false,
        hollow = false,
        small = false
    }
) {
    const [backgroundColor, setBackgroundColor] = useState('00C6B2');

    useEffect(() => {
        let newBackgroundColor = '00C6B2';

        if (background) {
            newBackgroundColor = background;
        } else if (status?.toLowerCase() === 'away' || status?.toLowerCase() === 'vehicle off road') {
            newBackgroundColor = 'FF7454';
        } else if (status?.toLowerCase() === 'inactive') {
            newBackgroundColor = 'EC2D6D';
        }

        setBackgroundColor(newBackgroundColor);
    }, [background, status]);

    return (
        <Tooltip position={Position.TOP} content={tooltip}>
            <div style={{ backgroundColor: hollow ? 'transparent' : `#${backgroundColor}`, borderColor: `#${backgroundColor}` }} className={classNames({ "bp6-skeleton": loading }, { "hollow": hollow }, "circle-status", "inline-items")}>
                <ShowHide
                    evaluator={!!iconClass}
                    show={<i className={iconClass} />}
                />
            </div>
        </Tooltip>
    );
}

CircleStatus.propTypes = {
    background: PropTypes.string,
    status: PropTypes.string,
    iconClass: PropTypes.string,
    tooltip: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    loading: PropTypes.bool,
    hollow: PropTypes.bool,
    small: PropTypes.bool
};